import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertComponent',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.alerts, (alert, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "fixed top-6 left-0 right-0 w-fit m-auto flex flex-col justify-start items-center z-[9999]"
    }, [
      _createVNode(_Transition, {
        "enter-active-class": "ease-in duration-200",
        "enter-from-class": "translate-x-20 opacity-20",
        "enter-to-class": "translate-x-0 opacity-100",
        "leave-active-class": "ease-in duration-200",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_alert, {
            message: alert.message,
            type: alert.type,
            "show-icon": "",
            closable: "",
            onClose: _cache[0] || (_cache[0] = () => _unref(store).dispatch('clearAlert'))
          }, null, 8, ["message", "type"])
        ]),
        _: 2
      }, 1024)
    ]))
  }), 128))
}
}

})